<template>
  <div class="container">
    <label v-if="label" class="label" :style="{ color: labelColor }">{{ label }}</label>
    <div class="textarea-container shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">
      <textarea
        class="textarea"
        :class="[textareaClass, { 'border-red-500': isInvalid }]"
        :placeholder="placeholder"
        :style="{ '--placeholder-color': placeholderColor, backgroundColor: bgColor, color: textColor }"
        :value="inputValue"
        @input="onInput"
        :rows="rows"
        :readonly="readonly"
        :disabled="disabled"
      ></textarea>
    </div>
    <p v-if="isInvalid" class="text-red-500 text-xs pt-1">Correo electrónico no válido</p>
    <p v-if="error" class="text-red-500 text-xs pt-1">{{ error }}</p>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  placeholder: String,
  label: String,
  modelValue: String,
  labelColor: String,
  placeholderColor: String,
  bgColor: String,
  textColor: String,
  error: {
    type: String,
    default: ''
  },
  rows: {
    type: Number,
    default: 4
  },
  disabled: {
    type: Boolean,
    default: false
  },
  readonly: {
    type: Boolean,
    default: false
  },
  textareaClass: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['update:modelValue']);
const inputValue = ref(props.modelValue ?? '');
const isInvalid = ref(false);

// Actualiza el valor local cuando cambia desde fuera
watch(() => props.modelValue, (val) => {
  inputValue.value = val;
});

// Verifica y emite en cada cambio del textarea
const onInput = (e) => {
  const value = e.target.value;
  inputValue.value = value;
  emit('update:modelValue', value);
};
</script>

<style scoped>
.container {
  margin: 8px 0;
}
.label {
  font-size: 16px;
  margin-bottom: 8px;
  color: #385660;
}
.textarea-container {
  display: flex;
  align-items: center;
  border: 1px solid #3A5762;
  border-radius: 8px;
  padding: 12px;
}
.textarea {
  flex: 1;
  width: 100%;
  font-size: 14px;
  border: none;
  outline: none;
  color: #7CADB9;
  resize: none;
  min-height: 100px;
}

.textarea::placeholder {
  color: #B0BEC5;
}
</style>
